import { useCallback } from 'react';

import { useCriteriaState } from './useCriteriaState';
import { Combinator } from '../../types';

export const useCriteriaCombinatorState = () => {
  const {
    criteria: { combinator },
    setCriteria,
  } = useCriteriaState();
  const setCombinator = useCallback(
    (newCombinator?: Combinator) =>
      setCriteria((currentCriteria) => ({ ...currentCriteria, combinator: newCombinator })),
    [setCriteria],
  );
  return { combinator, setCombinator };
};
